import i18next from 'i18next';
import {conditionnalConfig} from "./useForm";

export const validators_deprecated = {
    email: (value, options={}) => {
        let tester = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        if (!value){
            if (options.required){
                return {result: false, message: i18next.t('widget.input.email.mandatory_error')};
            }
            return {result: true};
        }
        if(value?.length>254) {
            return {result: false, message: i18next.t('widget.input.email.length_error')};
        }
        let valid = tester.test(value);
        if(!valid) {
            return {result: false, message: i18next.t('widget.input.email.invalid_error')};
        }
        return {result: true};
    },
    barcode: (value, options={}) => {
        //Todo: Check the barcode format
        let digits = () => /^\d{8,13}$/g.test(value);
        let validlengths = [8, 12, 13];
        if (!value && options.required){
            return {result: false, message: i18next.t('widget.input.barcode.mandatory_error')};
        }
        if (!digits() || !validlengths.includes(value.length)) {
            return {result: false, message: i18next.t('widget.input.barcode.invalid_error')};
        }
        return {result: true};
    }
};

export const validators = {
    required: (value, form, options={}, error_message = null) => {
        if (options.conditional_display?.required && !conditionnalConfig(options.conditional_display.required , form)) {
            return {result: true};
        }
        let errorMessage = error_message?.required || i18next.t('widget.input.value.required');
        if (!value){
            return {result: false, message: errorMessage};
        }
        return {result: true};
    },
    email: (value, form, options={}, error_message = null) => {
        if (options.conditional_display?.display && !conditionnalConfig(options.conditional_display.display , form)) {
            return {result: true};
        }
        let errorMessageTooLong = error_message?.too_long || i18next.t('widget.input.email.length_error');
        let errorMessageInvalid = error_message?.invalid || i18next.t('widget.input.email.invalid_error');
        let tester = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        if (!value){
            return {result: true};
        }
        if(value.length>254) {
            return {result: false, message: errorMessageTooLong};
        }
        let valid = tester.test(value);
        if(!valid) {
            return {result: false, message: errorMessageInvalid};
        }
        return {result: true};
    },
    confirmation_email: (value, form, options={}, error_message = null) => {
        if (options.conditional_display?.display && !conditionnalConfig(options.conditional_display.display , form)) {
            return {result: true};
        }

        if (form['ws-5'] && form['ws-5'] !== value) {
            return {result: false, message: i18next.t('widget.input.email.email_confirmation_different')};
        }

        return {result: true};
    }
};


export const get_validator = (type, validator=null) => {//deprecated
    const typeName = i18next.exists(`widget.input.${type}.default_label`) ? i18next.t(`widget.input.${type}.default_label`) : type;
    if(validator!=null && (typeof validator === 'string')) {
        return (value) => {
            let reg = new RegExp(validator, 'g');
            return {
                result: reg.test(value),
                message: i18next.t('widget.input.value.invalid', { value: typeName })
            };
        };
    }

    if(validators_deprecated[type]) {
        return validators_deprecated[type];
    }

    return null;
}

export const get_validators = (validators_list=[]) => {
    return validators_list.reduce((acc, v) => {
        if (v.validator_type && validators[v.validator_type]) {
            acc.push((value, form, options) => validators[v.validator_type](value, form, options, v.error_message));
        }
        return acc;
    }, [])
}
